/** 此页面是支付宝小程序引导页，用于引导用户下载哈啰app */
import platform from '@/shared/utils/platform';
import router from '@/router';
import store from '@/store';
import { RouterV2Enum } from '@/router/router-names';
import { jumpToLocalPreRenderPage } from '@/shared/utils/jumpTo';
import { redirect } from '@/shared/utils/app-redirect';
import { Component, Vue } from 'vue-property-decorator';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import { commonDispatchPreRender } from '@/shared/utils/prerenderHelper';
import style from './index.module.scss';

@Component
export default class GuideDownload extends Vue {
  private redirectApp() {
    this.$ubtPageButton('finance_download_app');
    // 新项目授信成功支付宝引导页（/alipay-credit-guide），与老项目guide-download处理逻辑保持一致。需同步进行逻辑修改
    redirect();
  }

  private created() {
    // 如果页面url上不包含beyondMP=true&userGuid=，且是支付宝小程序或钉钉小程序
    if (!window.location.href.includes('beyondMP=true&userGuid=') && (platform.isAlipayMini || platform.isDingTalk)) {
      router.go(-1);

      const userGuid = store.state.base.originUserInfo.userGuid || '';
      // 需要使用支付宝浏览器打开，才能绕过检测
      jumpToLocalPreRenderPage(RouterV2Enum.guideDownload, `beyondMP=true&userGuid=${userGuid}`, true);
    }
  }

  private mounted() {
    if (IS_PRERENDERING) {
      commonDispatchPreRender();
    }
  }

  private render() {
    return (
      <div class={style.GuideDownload}>
          <div class={style.GuideDownloadTitle}>
            今日{ platform.isAlipayMini || platform.isAlipayBrowser ? '小程序' : ''}额度已经领完~
          </div>
          <div class={style.downloadWrapper}>
              <div class={style.downloadContent}>
                <div class={style.creditAmount}>
                  <p class={style.highAmount}>预计最高可借额度</p>
                  <p class={style.amount}>200,000<span class={style.unit}>元</span></p>
                </div>
                <div class={style.advantageBox}>
                  <div class={style.advantageWrapper}>
                    <div class={style.featureWrapper}>
                      <span class={style.iconLabel} data-tag="特权一"></span>
                      <span class={style.featureText}>App首次领额可享</span>
                    </div>
                    <div class={style.coupon}>
                      <span class={style.couponDescribe}>
                        <span class={style.couponNum}>30</span>
                        <span class={style.couponDay}>天</span>
                      </span>
                      <span class={[style.couponName, style.couponNameCenter]}>免息券</span>
                    </div>
                  </div>
                  <div class={style.advantageWrapper}>
                    <div class={style.featureWrapper}>
                      <span class={style.iconLabel} data-tag="特权二"></span>
                      <span class={style.featureText}>用款便捷</span>
                    </div>
                    <div class={style.coupon}>
                      <span class={style.couponDescribe}>一次<br></br>审批</span>
                      <span class={style.couponName}>
                        <span>有效期内</span><br></br>
                        <span>循环使用</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class={style.downloadBtnWrapper}>
                <div class={style.downloadBtn}
                onClick={this.redirectApp.bind(this)}
                >立即前往哈啰APP领取</div>
              </div>
          </div>
          <div class={style.bottomText}>
            <p>请前往“哈啰App首页-借钱-申请额度”</p>
            <p>实际权益以页面展示为准</p>
          </div>
      </div>
    );
  }
}
